var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { fullscreen: "", transition: "slide-x-reverse-transition" },
      model: {
        value: _vm.coVisible,
        callback: function($$v) {
          _vm.coVisible = $$v
        },
        expression: "coVisible"
      }
    },
    [
      _c("template", { slot: "activator" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "notification",
          attrs: { id: "notification-container" },
          on: { click: _vm.handleBackdropClick }
        },
        [
          _c(
            "div",
            {
              staticClass: "notification__container",
              attrs: { id: "notification-content" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "notification__back-button",
                  attrs: { color: "primary", flat: "", icon: "" },
                  on: {
                    click: function($event) {
                      _vm.coVisible = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("arrow_forward")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "py-3 pl-4" }, [
                _c("h1", { staticClass: "primary--text" }, [
                  _vm._v("Notifications")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-2" },
                [
                  _c(
                    "div",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-layout",
                        { staticStyle: { "z-index": "1" }, attrs: { row: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mr-3 notification__button",
                              style: _vm.getTextStyle(0),
                              on: {
                                click: function($event) {
                                  _vm.handleChangeTab(0)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "5px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(_vm.lblSetting.unreadNotification)
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "notification__button--active",
                                style: _vm.getStyle(0)
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mr-3 notification__button--plus",
                              style: _vm.getTextStyle(1),
                              on: {
                                click: function($event) {
                                  _vm.handleChangeTab(1)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "5px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t(_vm.lblSetting.displayAll))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "notification__button--active",
                                style: _vm.getStyle(1)
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "notification__tab-line" })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "mb-0 pb-0", attrs: { row: "" } },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _vm.markAsReadVisible
                            ? _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "pa-0 notification__item--button",
                                  attrs: {
                                    flat: "",
                                    loading: _vm.dtIsMarkasReadLoading
                                  },
                                  on: { click: _vm.handleMarkAllAsRead }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t(_vm.lblSetting.markAsRead))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.notificationVisibility
                            ? _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "pa-0 notification__item--button",
                                  attrs: {
                                    flat: "",
                                    loading: _vm.dtIsDeleting
                                  },
                                  on: { click: _vm.handleDeleteAll }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t(_vm.lblSetting.deleteAll))
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.todayVisible
                        ? _c(
                            "v-card-text",
                            { staticClass: "py-0 notification__label" },
                            [_vm._v(_vm._s(_vm.getText))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasNewItems
                        ? _c(
                            "v-layout",
                            {
                              attrs: {
                                "align-center": "",
                                "justify-center": "",
                                row: "",
                                "fill-height": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    round: "",
                                    loading: _vm.loadingVisible
                                  },
                                  on: { click: _vm.handleRefreshNotifications }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "primary--text",
                                      staticStyle: {
                                        "text-transform": "none",
                                        "font-size": "10px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$tc(
                                              _vm.lblSetting.buttonNewItems,
                                              _vm.hasNewItems,
                                              { count: _vm.hasNewItems }
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.notificationVisibility
                        ? _c(
                            "v-list",
                            { staticClass: "pt-0", attrs: { "two-line": "" } },
                            [
                              _vm._l(_vm.notificationItems, function(n, index) {
                                return [
                                  _c("notification-item", {
                                    attrs: {
                                      "created-date": _vm.getDateText(n, index),
                                      id: n.id,
                                      name: n.name,
                                      "redirect-to": _vm.$route.meta
                                        .view_ticket_chat
                                        ? n.redirectTo
                                        : "",
                                      "color-class": n.colorClass(),
                                      avatar: _vm.getAvatar(n),
                                      "text-color-class": n.textColorClass(),
                                      "avatar-text": n.textAvatar,
                                      message: _vm.getMessage(n),
                                      "sub-info": n.subInfo
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleOnClick($event, n)
                                      }
                                    }
                                  })
                                ]
                              }),
                              _vm._v(" "),
                              _vm.infinityLoadingVisible
                                ? _c("v-infinite-loading", {
                                    staticClass: "whitePure",
                                    on: {
                                      infinite: _vm.handleGetMoreNotifications
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.unradNotificationInfinityLoadingVisible
                                ? _c("v-infinite-loading", {
                                    staticClass: "whitePure",
                                    on: {
                                      infinite:
                                        _vm.handleGetMoreUnreadNotifications
                                    }
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm.notificationItems.length === 0
                        ? _c(
                            "v-layout",
                            {
                              staticClass: "mt-5",
                              attrs: {
                                "align-center": "",
                                "justify-center": "",
                                column: "",
                                "fill-height": ""
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "100", color: "#e2d4ff" } },
                                [_vm._v("tab_unselected")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass: "mt-3 mb-1",
                                  staticStyle: { color: "#e2d4ff" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(_vm.lblSetting.emptyNotification)
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticStyle: { color: "#e2d4ff" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        _vm.lblSetting
                                          .emptyNotificationDescription
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loadingVisible
                        ? _c(
                            "v-layout",
                            {
                              staticClass: "mt-5",
                              attrs: {
                                "align-center": "",
                                "justify-center": "",
                                row: "",
                                "fill-height": ""
                              }
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  size: 30,
                                  width: 3,
                                  color: "primary",
                                  indeterminate: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-412630a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-412630a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/header-notifications/template.html
// module id = null
// module chunks = 